import {
  getHiddenPageCount,
  getPageTagTone,
  getVisiblePages,
} from '../classifyManage/classifyListHelpers'

export { getPageTagTone, getVisiblePages, getHiddenPageCount }

/** 页面类型 pill：常见类型走固定色，其余 neutral。 */
export function getPageTypeVariant(typeName) {
  const key = String(typeName || '').trim().toLowerCase()
  if (!key) return 'neutral'
  if (/主信息流|feed|home/.test(key)) return 'sky'
  if (/详情|detail/.test(key)) return 'violet'
  if (/搜索|search/.test(key)) return 'amber'
  if (/tab|标签|分类/.test(key)) return 'teal'
  if (/弹窗|dialog|modal/.test(key)) return 'rose'
  return 'neutral'
}
